import React from 'react';
import { Link } from 'react-router-dom';
import moment from "moment";

function KasmTable(props) {
    const live_kasms = props.kasms && props.kasms.map((kasm, i) => {
        return <tr key={i}>
            <td>
                <Link to={"/viewkasm/" + kasm.kasm_id}>
                    {kasm.kasm_id}
                </Link>
            </td>
            <td>
                <Link to={"/viewuser/" + kasm.user_id}>
                    {kasm.user.username}
                </Link>
            </td>
            <td>
                <Link to={"/viewimage/" + kasm.image_id}>
                    {kasm.image.friendly_name}
                </Link>
            </td>
            <td>
                {moment.utc(kasm.current_time).diff(moment.utc(kasm.created_date), "days" ) ?
                 moment.utc(kasm.current_time).diff(moment.utc(kasm.created_date), "days" ) + "d:" : ""}
                {moment.utc(moment.utc(props.current_time).diff(moment.utc(kasm.created_date), "hh:mm:ss")).format("HH:mm:ss")}
                </td>
        </tr>
    });


    return (
        <div style={{maxHeight:'250px', overflowY:'auto'}}>
            <table style={{width:'100%'}} className="black-link">
                <thead>
                    <tr>
                        <th>Kasm Id</th>
                        <th>User</th>
                        <th>Image</th>
                        <th>Uptime</th>
                    </tr>
                </thead>
                <tbody>
                {live_kasms.length > 0 ? live_kasms: <tr><td>No Live Sessions</td></tr>}
                </tbody>
            </table>
        </div>
    );
}

export default KasmTable;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/KasmTable.js